import { Clipboard } from '@angular/cdk/clipboard';
import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { LangService } from './lang/lang.service';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  private clipboard = inject(Clipboard);
  private labels = inject(LangService).lang.shared.clipboard;
  private toastrService = inject(ToastrService);

  private copied() {
    this.toastrService.success(this.labels.successMessage);
  }

  copyToClipboard(str: string) {
    const pending = this.clipboard.beginCopy(str);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      } else {
        pending.destroy();
        this.copied();
      }
    };
    attempt();
  }
}
